<template>
  <div>
    <section>
      <h4 class="text-bold">Dedicated Persons</h4>
      <v-chip-group multiple active-class="secondary--text" v-model="selectedDedicatedPersons" column>
        <div :key="typeIndex" v-for="(userType, typeIndex) in userTypes">
          <p class="h4 font-weight-bold mb-0">{{userType.title}}</p>
          <div class="mb-2" style="margin-left: -7px">
            <v-chip v-for="(item, index) in filterByRole(assignUsers, userType.role)" :key="index" :value="item"
              class="ma-2"
              filter
              :readonly="viewMode"
            >
              <v-avatar style="margin-right:5px;">
                <v-icon>account_circle</v-icon>
              </v-avatar>
              {{item.firstName + ' ' + item.lastName}}
            </v-chip>
          </div>
        </div>
      </v-chip-group>
    </section>
    <hr>
    <section>
      <h4 class="text-bold">Supporting Persons</h4>
      <v-chip-group multiple active-class="secondary--text" v-model="selectedSupportingPersons" column>
        <div :key="typeIndex" v-for="(userType, typeIndex) in userTypes">
          <p class="h4 font-weight-bold mb-0">{{userType.title}}</p>
          <div class="mb-2" style="margin-left: -7px">
            <v-chip v-for="(item, index) in filterByRole(computedSupportingPersons, userType.role)" :key="index" :value="item"
              class="ma-2"
              filter
              :readonly="viewMode"
            >
              <v-avatar style="margin-right:5px;">
                <v-icon>account_circle</v-icon>
              </v-avatar>
              {{item.firstName + ' ' + item.lastName}}
            </v-chip>
          </div>
        </div>
      </v-chip-group>
    </section>
  </div>
</template>
<script>
import config from '@/config';
export default {
  name: 'AssignTeam',
  props: [
    'assignUsers',
    'dedicatedData',
    'supportingData',
    'viewMode'
  ],
  data() {
    return {
      userRoles: config.userRoles,
      userTypes: [
        {
          title: 'AM',
          role: config.userRoles.ACCOUNT_MANAGER
        },
        {
          title: 'CC',
          role: config.userRoles.AD_STRATEGIST
        }
      ],
      selectedDedicatedPersons: [],
      selectedSupportingPersons: [],
      AMUsers: [],
      CCUsers: []
    }
  },
  computed: {
    computedSupportingPersons() {
      // exclude selected dedicated persons in supporting lists
      let personIds = this.selectedDedicatedPersons.map(v => v.id)
      return this.assignUsers.filter(a => !personIds.includes(a.id))
    }
  },
  watch: {
    dedicatedData(newValues) {
      this.getAMCCUsers()
      this.selectedDedicatedPersons = newValues.map(s => s)
    },
    supportingData(newValues) {
      this.selectedSupportingPersons = newValues.map(s => s)
    },
    selectedDedicatedPersons: function(newValue) {
      if ((this.dedicatedData && this.dedicatedData.length < 3) || !this.dedicatedData) {
        let newIds = newValue.map(v => v.id)
        // only one AM User select for dedicated persons
        let totalAMs = newIds.filter(v => this.AMUsers.includes(v))
        if (totalAMs.length > 1) {
          let removeAM = totalAMs[0]
          newValue = newValue.filter(v => v.id !== removeAM)
        }
        // only one CC select for dedicated persons
        let totalCCs = newIds.filter(v => this.CCUsers.includes(v))
        if (totalCCs.length > 1) {
          let removeCC = totalCCs[0]
          newValue = newValue.filter(v => v.id !== removeCC)
        }
        if (totalAMs.length > 1 || totalCCs.length > 1) {
          this.selectedDedicatedPersons = newValue
        }
        this.selectedSupportingPersons = this.selectedSupportingPersons.filter(s => !newValue.includes(s.id))
      }
      this.$emit('updateSelectedDedicated', newValue)
    },
    selectedSupportingPersons: function(newValue) {
      this.$emit('updateSelectedSupporting', newValue)
    }
  },
  mounted() {
    this.selectedDedicatedPersons = Object.assign([], this.dedicatedData)
    this.selectedSupportingPersons = Object.assign([], this.supportingData)
    this.getAMCCUsers()
  },
  methods: {
    filterByRole(users, role) {
      return users.filter(u => u.role === role)
    },
    getAMCCUsers() {
      this.AMUsers = this.filterByRole(this.assignUsers, config.userRoles.ACCOUNT_MANAGER)
      this.AMUsers = this.AMUsers.map(a => a.id)
      this.CCUsers = this.filterByRole(this.assignUsers, config.userRoles.AD_STRATEGIST)
      this.CCUsers = this.CCUsers.map(a => a.id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// AssignTeam.vue?bb372b4e